export const getScrollingPropertyValue = isScrollable => {
  let scrolling = 'auto';
  if (typeof isScrollable !== 'undefined') {
    scrolling = isScrollable ? 'yes' : 'no';
  }
  return scrolling;
};
